import {PVRPrint3D,EPVRPrint3D} from "./webgl/Tools/PVRPrint3D";
import { PVRMatrix4x4, PVRVector3 } from "./webgl/Tools/PVRMaths";
import PVRShader from "./webgl/Tools/PVRShader";
import PVRTexture from "./webgl/Tools/PVRTexture";
import PVRFileStream from "./webgl/Tools/PVRFileStream";
import PVRModel from   "./webgl/Tools/PVRModel";
import {PVRPODLoader, EPODErrorCodes} from  "./webgl/Tools/PVRPODLoader";
/******************************************************************************

 @File         OGLES2FilmTV.cpp

 @Title        Introducing the POD 3D file format

 @Version      

 @Copyright    Copyright (c) Imagination Technologies Limited.

 @Platform     Independent

 @Description  Shows how to load POD files and play the animation with basic
               lighting




/******************************************************************************
 Consts
******************************************************************************/
// Camera constants. Used for making the projection matrix

const VERTEX_ARRAY =	0
const NORMAL_ARRAY =	1
const TEXCOORD_ARRAY	 =2

const PVRT_PI = 3.1415926535;
const  g_fCameraNear = 1.0;
const  g_fCameraFar  = 150.0;

// The camera to use from the pod file
const  g_ui32Camera = 0;

const  g_ui32CameraLoopSpeed = 10.0;
const   g_ui32CameraMesh = 9;
const  g_ui32TvScreen = 7;

/******************************************************************************
 Content file names
******************************************************************************/

// Source and binary shaders
const  c_szFragShaderSrcFile	= "FilmFragShader.fsh";
const  c_szFragShaderBinFile	= "FilmFragShader.fsc";
const  c_szBWFragShaderSrcFile = "BWFragShader.fsh";
const  c_szBWFragShaderBinFile = "BWFragShader.fsc";
const  c_szVertShaderSrcFile	= "FilmVertShader.vsh";
const  c_szVertShaderBinFile	= "FilmVertShader.vsc";

// POD scene files
const  c_szSceneFile			= "FilmTVScene.pod";

/*!****************************************************************************
 Class implementing the PVRShell functions.
******************************************************************************/
 const WebGLFilmTV = function(data)
{






let documentData = data
   
let dataResult = function(thisdata, a, b)  {
     
    return   thisdata.filter(function(elt)  {
        return elt.endsWith(b) && elt.includes(a)
    })[0]
    }


const myresult = (documentData.allFile.edges.map((file, index) => {return (file.node.publicURL ) }))


let getFileLocation = function(name) {
	const dataResult = function(thisdata, a, b)  {
		return   thisdata.filter(function(elt)  {
			return elt.endsWith(b) && elt.includes(a)
		})[0]
		}
		let r1 = name.split(".")
		let l   = r1.length;
		let filename = r1[0];
		for (let i =1; i<l-1; i++) filename += r1[i];
		//let result = data.allFile.edges.map((file, index) => {return (file.node.publicURL ) })
			return (
				dataResult(myresult, r1[0],r1[l-1])
			)
		}



	// Print3D class used to display text
	let	m_Print3D = new PVRPrint3D(myresult);

	// 3D Model
	//let CPVRTModelPOD	;

	// OpenGL handles for shaders, textures and VBOs
let  m_uiVertShader = {};
let m_uiFragShader ={};
let m_uiBWFragShader = {};
let m_puiVbo = [];
let m_puiIndexVbo = [];

let	m_i32OriginalFB = null;

	// Group shader programs and their uniform locations together
	 const Shader = function()
	{
		this.uiId = {};
		this.uiMVPMatrixLoc= {};
		this.uiLightPosLoc = {};
	}
    let m_ShaderProgram = new Shader();
    let m_BWShaderProgram = new Shader();

	// App Variables
	let 		 m_i32TexSize = 1;

	let 	m_uiTexture = [];
    let	m_uiFbo = [];
	let	m_uiDepthBuffer = [];
	let 		m_i32CurrentFBO = 1;
	let 		m_uiTVScreen = -1;
	let 		m_i32Frame = 0;

	let m_MiniCamView = new PVRMatrix4x4();
	let m_MiniCamViewProj = new PVRMatrix4x4();
	let m_View = new PVRMatrix4x4();
	let m_ViewProjection = new PVRMatrix4x4();

    // Extensions
    
  //let m_Extensions = new  CPVRTgles2Ext();

	// Discard the frame buffer attachments
	let m_bDiscard = false;

    // A boolean to indicate that our FBOs were created successfully
    let  m_bFBOsCreated = false;

/*!****************************************************************************
 @Function		LoadTextures
 @Return		bool			true if no error occured
 @Description	Loads the textures required for this training course
******************************************************************************/
//bool WebGLFilmTV.prototype.LoadTextures(CPVRTString* pErrorStr)

//******************************************************************************/
 WebGLFilmTV.prototype.loadTextures = function(gl)
{
	/*
		Loads the textures.
		For a more detailed explanation, see Texturing and IntroducingPVRTools
	*/

	/*
		Initialises an array to lookup the textures
		for each material in the scene.
	*/
	this.m_puiTextureIDs = new Array(this.m_Scene.data.numMaterials);
    this.LoadingTextures = this.m_Scene.data.numMaterials;
	if(!this.m_puiTextureIDs)
	{
		console.error( "ERROR: Insufficient memory.");
		return false;
	}

	for(let i = 0; i < this.m_Scene.data.numMaterials; ++i)
	{
		this.m_puiTextureIDs[i] = {};
	   let pMaterial = this.m_Scene.data.materials[i];  //	SPODMaterial*

		if(pMaterial.data.diffuseTextureIndex !== -1)
		{
			/*
				Using the tools function PVRTTextureLoadFromPVR load the textures required by the pod file.

				Note: This function only loads .pvr files. You can set the textures in 3D Studio Max to .pvr
				files using the PVRTexTool plug-in for max. Alternatively, the pod material properties can be
				modified in PVRShaman.
			*/

			let sTextureName = this.m_Scene.data.textures[pMaterial.data.diffuseTextureIndex].data.name;

			if(sTextureName === "TV.pvr"){
			
				m_uiTVScreen = i;}
				
		

		       //PVRTexture.loadFromURI(sTextureName, m_puiTextureIDs[i])
               (function(demo)
               {
               
                   PVRTexture.loadFromURI(gl, getFileLocation(sTextureName), 0,
                       function(gl, id, h)
                       {
                   
                           demo.m_puiTextureIDs[i] = id;
                           //Clear the bit that denotes that this texture is loaded

                           if(gl.getError()) { 
							alert(sTextureName) ;  
							alert("Error while loading texture!"); }
						 
						   gl.bindTexture(gl.TEXTURE_2D, id);

						   gl.texParameterf(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
						   gl.texParameterf(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
						  
							  gl.texParameterf(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
						      gl.texParameterf(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.REPEAT);
						  
							 // gl.texParameterf(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
							 // gl.texParameterf(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
						  

                        //    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
                        //     gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
                        //    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
                        //     gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
                           
                           demo.LoadingTextures  -= 1;//&= ~(1<<1);
                       
                       });
               })( this);
        }
    
	}

	return true;
}

/*!****************************************************************************
 @Function		LoadShaders
 @Output		pErrorStr		A string describing the error on failure
 @Return		bool			true if no error occurred
 @Description	Loads and compiles the shaders and links the shader programs
				required for this training course
******************************************************************************/
//bool WebGLFilmTV.prototype.LoadShaders(CPVRTString* pErrorStr)
 WebGLFilmTV.prototype.loadShaders = function(gl)
{
	/*
		Load and compile the shaders from files.
		Binary shaders are tried first, source shaders
		are used as fallback.
    */  


    


   m_uiVertShader = PVRShader.loadFromURI(gl,getFileLocation(c_szVertShaderSrcFile), gl.VERTEX_SHADER,[], function(e){alert(e);}) ;

  m_uiFragShader =	PVRShader.loadFromURI(gl,getFileLocation(c_szFragShaderSrcFile), gl.FRAGMENT_SHADER ,  [], function(e){alert(e);});

	/*
		Set up and link the shader program
	*/
	const  aszAttribs = [ "inVertex", "inNormal", "inTexCoord" ];

    m_ShaderProgram.uiId = PVRShader.createProgram(gl,m_uiVertShader, m_uiFragShader, aszAttribs, function(e){alert(e);}); ;


	// Set the sampler2D variable to the first texture unit
	gl.uniform1i(gl.getUniformLocation(m_ShaderProgram.uiId, "sTexture"), 0);

	// Store the location of uniforms for later use
	m_ShaderProgram.uiMVPMatrixLoc	= gl.getUniformLocation(m_ShaderProgram.uiId, "MVPMatrix");
	m_ShaderProgram.uiLightPosLoc	= gl.getUniformLocation(m_ShaderProgram.uiId, "LightPosition");

	// Load and compile the Black and White shader used on the TV screen
    m_uiBWFragShader =  PVRShader.loadFromURI(gl,getFileLocation(c_szBWFragShaderSrcFile), gl.FRAGMENT_SHADER ,  [], function(e){alert(e);});
	
	// Set up and link the shader program (re-using the already loaded vertex shader
	m_BWShaderProgram.uiId  =  PVRShader.createProgram(gl, m_uiVertShader, m_uiBWFragShader, aszAttribs, function(e){alert(e);});

	// Set the sampler2D variable to the first texture unit
	gl.uniform1i(gl.getUniformLocation(m_BWShaderProgram.uiId, "sTexture"), 0);

	// Store the location of uniforms for later use
	m_BWShaderProgram.uiMVPMatrixLoc= gl.getUniformLocation(m_BWShaderProgram.uiId, "MVPMatrix");
	m_BWShaderProgram.uiLightPosLoc	= gl.getUniformLocation(m_BWShaderProgram.uiId, "LightPosition");

	return true;
}

/*!****************************************************************************
 @Function		LoadVbos
 @Description	Loads the mesh data required for this training course into
				vertex buffer objects
******************************************************************************/
//ool WebGLFilmTV.prototype.LoadVbos(CPVRTString* pErrorStr)
 WebGLFilmTV.prototype.loadVbos = function(gl)
{
	// if(!this.m_Scene.data.meshes[0].pInterleaved)
	// {
	//    console.log( "ERROR: FilmTV requires the pod data to be interleaved. Please re-export with the interleaved option enabled.");
	//   return false;
	// }

	if (!m_puiVbo)      m_puiVbo = new Array(this.m_Scene.data.numMeshes);
	if (!m_puiIndexVbo) m_puiIndexVbo = new Array(this.m_Scene.data.numMeshes);

	/*
		Load vertex data of all meshes in the scene into VBOs

		The meshes have been exported with the "Interleave Vectors" option,
		so all data is interleaved in the buffer at pMesh->pInterleaved.
		Interleaving data improves the memory access pattern and cache efficiency,
		thus it can be read faster by the hardware.
	*/
   // glGenBuffers(this.m_Scene.nNumMesh, m_puiVbo);
   
	for (let i = 0; i < this.m_Scene.data.numMeshes; ++i)
	{
		// Load vertex data into buffer object
		let Mesh = this.m_Scene.data.meshes[i];
       // let  uiSize = Mesh.nNumVertex * Mesh.sVertex.nStride;
        m_puiVbo[i] = gl.createBuffer();
		gl.bindBuffer(gl.ARRAY_BUFFER, m_puiVbo[i]);
		gl.bufferData(gl.ARRAY_BUFFER, Mesh.data.vertexElementData[0], gl.STATIC_DRAW);

		// Load index data into buffer object if available
		//m_puiIndexVbo[i] = {};
		if (Mesh.data.faces.data)
		{
            m_puiIndexVbo[i] = gl.createBuffer();
			//glGenBuffers(1, &m_puiIndexVbo[i]);
			//uiSize =   mesh.GetNumberOfIndices() * 2; // PVRTModelPODCountIndices(Mesh) *   2 ; //sizeof(GLshort);
			gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, m_puiIndexVbo[i]);
			gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, Mesh.data.faces.data, gl.STATIC_DRAW);
		}
	}
	gl.bindBuffer(gl.ARRAY_BUFFER, null);
	gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);

	return true;
}

/*!****************************************************************************
 @Function		InitApplication
 @Return		bool		true if no error occurred
 @Description	Code in InitApplication() will be called by PVRShell once per
				run, before the rendering context is created.
				Used to initialize variables that are not dependant on it
				(e.g. external modules, loading meshes, etc.)
				If the rendering context is lost, InitApplication() will
				not be called again.
******************************************************************************/
//bool WebGLFilmTV.prototype.InitApplication()
 WebGLFilmTV.prototype.initApplication = function (PVRShell)
{
	this.finishingUpdate = false;
	this.finishingUpdate1 = false;
	this.once = true;
	this.oncePick = true;
    this.m_puiTextureIDs = [];
    this.LoadingModels = 1;
    this.LoadingTextures = 1000;
    this.m_Scene = {};
	// Get and set the read path for content files
//	CPVRTResourceFile::SetReadPath((char*)PVRShellGet(prefReadPath));

	// Get and set the load/release functions for loading external files.
	// In the majority of cases the PVRShell will return NULL function pointers implying that
	// nothing special is required to load external files.
//	CPVRTResourceFile::SetLoadReleaseFunctions(PVRShellGet(prefLoadFileFunc), PVRShellGet(prefReleaseFileFunc));

	// Load the scene
	

	return true;
}

/*!****************************************************************************
 @Function		QuitApplication
 @Return		bool		true if no error occurred
 @Description	Code in QuitApplication() will be called by PVRShell once per
				run, just before exiting the program.
				If the rendering context is lost, QuitApplication() will
				not be called.
******************************************************************************/
 WebGLFilmTV.prototype.quitApplication = function()
{
	// Free the memory allocated for the scene
	this.m_Scene.destroy();

	 m_puiVbo = null;
	 m_puiIndexVbo = null;

    return true;
}



const loadPOD= function(stream, demo, gl){

    demo.m_Scene = new PVRModel();
    let podLoader    = new PVRPODLoader();
    let result       = podLoader.load(stream, demo.m_Scene);
    if(result !== EPODErrorCodes.eNoError)
    {
        alert("Failed to load POD: " + result);
        return;
	}
	//console.log(demo)

    demo.loadVbos(gl);
    



	// {
	// 	console.error("ERROR: Couldn't load '" , c_szSceneFile + "'.");
	// //	PVRShellSet(prefExitMessage, ErrorStr.c_str());
	// 	return false;
	// }

	// The cameras are stored in the file. We check it contains at least one.
	if(demo.m_Scene.data.numCameras === 0)
	{
		console.error( "ERROR: The scene does not contain a camera. Please add one and re-export.\n");
		return false;
	}

	// We also check that the scene contains at least one light
	if(demo.m_Scene.data.numLights === 0)
	{
		console.error(  "ERROR: The scene does not contain a light. Please add one and re-export.\n");
		return false;
    }
	demo.loadTextures(gl)
    demo.LoadingModels = 0;
    
}

WebGLFilmTV.prototype.upDateFile = function(gl, PVRShell){
	// Find the largest square power of two texture that fits into the viewport
	 m_i32TexSize = 1;
	let iSize =   Math.min(PVRShell.data.width, PVRShell.data.height);
	while (m_i32TexSize * 2 < iSize) m_i32TexSize *= 2;

	
	// Get the currently bound frame buffer object. On most platforms this just gives 0.
	//m_i32OriginalFB = gl.createFrameBuffer();
	//gl.getIntegerv(gl.FRAMEBUFFER_BINDING, m_i32OriginalFB);

	m_i32OriginalFB = gl.getParameter(gl.FRAMEBUFFER_BINDING);
	
	

	for(let i = 0; i < 2; ++i)
	{
		// Create texture for the FBO
		m_uiTexture[i] = gl.createTexture();
		gl.bindTexture(gl.TEXTURE_2D, m_uiTexture[i]);

		//var ext = gl.getExtension('WEBGL_depth_texture');

		//gl.copyTexImage2D(gl.TEXTURE_2D, 0, gl.RGB, 0, 0, m_i32TexSize, m_i32TexSize, 0);
		
		gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, m_i32TexSize, m_i32TexSize, 0, gl.RGB, gl.UNSIGNED_SHORT_5_6_5, null );
	//	gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, m_i32TexSize, m_i32TexSize, 0, gl.RGBA, gl.UNSIGNED_BYTE, null );
	
		//gl.texImage2D(eTextureTarget, MIPLevel-loadFromLevel, textureInternalFormat, MIPWidth, MIPHeight, 0, textureFormat, textureType, textureData);
		
		gl.texParameterf(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
//	gl.texParameterf(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
	gl.texParameterf(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
		gl.texParameterf(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
		gl.texParameterf(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
	//	gl.texParameterf(gl.TEXTURE_2D, gl.GENERATE_MIPMAP, true);
	 //   gl.bindTexture(gl.TEXTURE_2D,null);
		// Create FBO

		

	
	  //  glGenRenderbuffers(1, &[i]);
	  m_uiDepthBuffer[i] = gl.createRenderbuffer();
        
		gl.bindRenderbuffer(gl.RENDERBUFFER, m_uiDepthBuffer[i]);

		gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_COMPONENT16, m_i32TexSize, m_i32TexSize);
	//	gl.bindRenderbuffer(gl.RENDERBUFFER, null);
		

			//gl.bindTexture(gl.TEXTURE_2D, m_uiTexture[i]);
			m_uiFbo[i] = gl.createFramebuffer() ;
		
			//	glGenFramebuffers(1, &);
			  gl.bindFramebuffer(gl.FRAMEBUFFER, m_uiFbo[i]);
			  gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, m_uiTexture[i], 0);		 
		gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.RENDERBUFFER, m_uiDepthBuffer[i]);

	  
        // Check that our FBO creation was successful
        let uStatus = gl.checkFramebufferStatus(gl.FRAMEBUFFER);

        if(uStatus !== gl.FRAMEBUFFER_COMPLETE)
        {
		alert("error in create FBO");
            m_bFBOsCreated = false;
            alert("ERROR: Failed to initialise FBO");
            break;
		}
		else{
		
			m_bFBOsCreated = true;
		}

		// Clear the colour buffer for this FBO
		gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
	}

	gl.bindFramebuffer(gl.FRAMEBUFFER, m_i32OriginalFB);

	 this.finishingUpdate1 = true;
	
	
}


WebGLFilmTV.prototype.upDate = function(gl, PVRShell)
{

	// Setup the main camera
   //PVRTVec3	
   let vFrom = new PVRVector3();
   let vTo = new PVRVector3(0.0,0.0,0.0);
   let vUp =  new PVRVector3(0.0, 1.0,0.0);
   let  fFOV =  0.0;

   // Camera nodes are after the mesh and light nodes in the array
   let i32CamID = this.m_Scene.data.nodes[this.m_Scene.data.numMeshNodes + this.m_Scene.data.numLights + g_ui32Camera].data.index;

   // Get the camera position, target and field of view (fov)
   if(this.m_Scene.data.cameras[i32CamID].data.targetIndex !== -1) // Does the camera have a target?
{
	  // fFOV = this.m_Scene.getCameraPos( vFrom, vTo, g_ui32Camera); // vTo is taken from the target node
	  let props = this.m_Scene.getCameraProperties(g_ui32Camera);
	  fFOV = props.fov;
	  vFrom = props.from;
	  vTo = props.to;}

   else   fFOV = this.m_Scene.getCamera( vFrom, vTo, vUp, g_ui32Camera); // vTo is calculated from the rotation

   

   m_View =  PVRMatrix4x4.createLookAt(vFrom, vTo, vUp);//  PVRTMat4::LookAtRH(vFrom, vTo, vUp);

   // Calculate the projection matrix
   let mProjection = PVRMatrix4x4.createPerspectiveProjection(g_fCameraNear, g_fCameraFar, fFOV, PVRShell.data.width/PVRShell.data.height) //  PVRTMat4::OGL, bRotate);
   m_ViewProjection = PVRMatrix4x4.matrixMultiply( mProjection , m_View);
  
   // Check to see if the gl.EXT_discard_framebuffer extension is supported
   // if(m_bFBOsCreated && (m_bDiscard = CPVRTgles2Ext.isGLExtensionSupported("gl.EXT_discard_framebuffer")) !== false)
   // {
   // 	m_Extensions.loadExtensions();
   // 	m_bDiscard = m_Extensions.glDiscardFramebufferEXT !== 0;
   // }
   this.finishingUpdate = true;
  return true;
}
/*!****************************************************************************
 @Function		InitView
 @Return		bool		true if no error occurred
 @Description	Code in InitView() will be called by PVRShell upon
				initialization or after a change in the rendering context.
				Used to initialize variables that are dependant on the rendering
				context (e.g. textures, vertex buffers, etc.)
******************************************************************************/
 WebGLFilmTV.prototype.initView = function(gl, PVRShell)
{
    
    (function(demo, gl)
    {
        let fs = new PVRFileStream();
        fs.Open(getFileLocation( c_szSceneFile), true, loadPOD, demo, gl);
    })(this, gl);
   



	// //	Initialize VBO data
	// if(!this.loadVbos())
	// {
	
	// 	return false;
	// }

	//	Load textures
	// if(!this.loadTextures(gl))
	// {
		
	// 	return false;
	// }

	//	Load and compile the shaders & link programs
	if(!this.loadShaders(gl))
	{
	
		return false;
	}

	//	Initialize Print3D
	//let bRotate = PVRShellGet(prefIsRotated) && PVRShellGet(prefFullScreen);

	m_Print3D.setTextures(gl,PVRShell.data.width ,PVRShell.data.height); 
	// {
	// 	PVRShellSet(prefExitMessage, "ERROR: Cannot initialise Print3D\n");
	// 	return false;
	// }

	//Set OpenGL ES render states needed for this demo

	// // Enable backface culling and depth test
	gl.cullFace(gl.BACK);
	gl.enable(gl.CULL_FACE);

	gl.enable(gl.DEPTH_TEST);

	gl.clearColor(0.0, 0.0, 0.0, 1.0);


	//this.upDateFile(gl, PVRShell);

	return true;
}

/*!****************************************************************************
 @Function		ReleaseView
 @Return		bool		true if no error occurred
 @Description	Code in ReleaseView() will be called by PVRShell when the
				application quits or before a change in the rendering context.
******************************************************************************/
WebGLFilmTV.prototype.releaseView= function(gl)
//bool WebGLFilmTV.prototype.ReleaseView()
{
	// Delete program and shader objects
	gl.deleteProgram(m_ShaderProgram.uiId);
	gl.deleteProgram(m_BWShaderProgram.uiId);

	gl.deleteShader(m_uiVertShader);
	gl.deleteShader(m_uiFragShader);
	gl.deleteShader(m_uiBWFragShader);

	// Delete buffer objects
	//gl.deleteBuffers(this.m_Scene.nNumMesh, m_puiVbo);
    //gl.deleteBuffers(this.m_Scene.nNumMesh, m_puiIndexVbo);
    m_puiVbo.forEach(x=>gl.deleteBuffer(x));
    m_puiIndexVbo.forEach(x=>gl.deleteBuffer(x));
	//gl.deleteFramebuffers(2, m_uiFbo);
    m_uiFbo.forEach(x=>gl.deleteFramebuffer(x));
	// Delete our depth buffer render buffers
	// gl.deleteRenderbuffers(2, m_uiDepthBuffer);
    m_uiDepthBuffer.forEach(x=>gl.deleteRenderbuffer(x));
	// Release Print3D Textures
	m_Print3D.releaseTextures();

	// Deletes the textures
	//gl.deleteTextures(this.m_Scene.nNumMaterial, m_puiTextureIDs[0]);
    
   this.m_puiTextureIDs.forEach(x=> gl.deleteTexture(x));
    m_uiTexture.forEach(x=> gl.deleteTexture(x));
    //gl.deleteTextures(2, m_uiTexture[0]);

	// Frees the texture lookup array
	 this.m_puiTextureIDs = null;

	return true;
}


 WebGLFilmTV.prototype.calcMiniCameraView = function(PVRShell)
{
	let fValue = PVRShell.getTimeNow() * 0.001 * 2.0 * PVRT_PI;

	let fZ = 1.0 + (2.40 * Math.sin(fValue * 1.0 / g_ui32CameraLoopSpeed));
	let fX = 0.50 * Math.cos(fValue * 2.0 / g_ui32CameraLoopSpeed);
	let fCamRot = 0.16 * Math.sin(fValue * 1.0 / g_ui32CameraLoopSpeed) - 0.17;

	m_MiniCamView  = PVRMatrix4x4.createRotationX3D(Math.atan2(fX, 10.0));
	m_MiniCamView = PVRMatrix4x4.matrixMultiply( m_MiniCamView ,     PVRMatrix4x4.createRotationY3D(fCamRot));
	m_MiniCamView = PVRMatrix4x4.matrixMultiply( m_MiniCamView ,PVRMatrix4x4.createRotationZ3D(Math.atan2(fZ, 10.0)));

	// Setup the mini camera's view projection matrix
	let mProjection = PVRMatrix4x4.createPerspectiveProjection(g_fCameraNear, g_fCameraFar, 70.0 * (PVRT_PI / 180.0), 1);
	m_MiniCamViewProj = PVRMatrix4x4.matrixMultiply(mProjection , m_MiniCamView);
}

/*!****************************************************************************
 @Function		RenderScene
 @Return		bool		true if no error occurred
 @Description	Main rendering loop function of the program. The shell will
				call this function every frame.
				eglSwapBuffers() will be performed by PVRShell automatically.
				PVRShell will also manage important OS events.
				Will also manage relevant OS events. The user has access to
				these events through an abstraction layer provided by PVRShell.
******************************************************************************/
// WebGLFilmTV.prototype.RenderScene()
 WebGLFilmTV.prototype.renderScene = function(gl, PVRShell)
{
    // Use shader program
	if ( this.LoadingModels  > 0 ) return true;
	
 if (this.LoadingTextures > 0) return true;


 if (this.once ){
    this.once = false;
	this.upDate(gl,PVRShell);
	return true;
 }

 if (!this.finishingUpdate) {return true;}
 


  if (this.oncePick){
 	this.oncePick = false;
	 this.upDateFile(gl,PVRShell);
	 
 	return true;
  }


  if (!this.finishingUpdate1) {return true;}




	gl.useProgram(m_ShaderProgram.uiId);

	// Enable the vertex attribute arrays
	gl.enableVertexAttribArray(VERTEX_ARRAY);
	gl.enableVertexAttribArray(NORMAL_ARRAY);

    // Render everything from the mini-camera's point of view if we have the FBOs
    this.calcMiniCameraView(PVRShell);

    if(m_bFBOsCreated)
    {
	
		// Setup the Viewport to the dimensions of the texture
		//console.log(m_i32TexSize);

		gl.viewport(0, 0, m_i32TexSize, m_i32TexSize);

		gl.bindFramebuffer(gl.FRAMEBUFFER, m_uiFbo[m_i32CurrentFBO]);

		this.drawPODScene(gl, m_MiniCamViewProj, false);

		if(m_bDiscard) // Was gl.EXT_discard_framebuffer supported?
		{
			/*
				Give the drivers a hint that we don't want the depth and stencil information stored for future use.

				Note: This training course doesn't have any stencil information so the STENCIL_ATTACHMENT enum 
				is used for demonstrations purposes only and will be ignored by the driver.
			*/
			let attachments = [ gl.DEPTH_ATTACHMENT, gl.STENCIL_ATTACHMENT ];
			//m_Extensions.glDiscardFramebufferEXT(gl.FRAMEBUFFER, 2, attachments);
		}

		
	
		
		gl.bindFramebuffer(gl.FRAMEBUFFER, m_i32OriginalFB);


		//  gl.bindTexture(gl.TEXTURE_2D, m_uiTexture[m_i32CurrentFBO]);
		//  gl.generateMipmap(gl.TEXTURE_2D);
		//  gl.bindTexture(gl.TEXTURE_2D, null);

		// Render everything

		// Setup the Viewport to the dimensions of the screen
		gl.viewport(0, 0, PVRShell.data.width, PVRShell.data.height );

		//m_bFBOsCreated = false;
		
    }


	this.drawPODScene(gl, m_ViewProjection, true);


	gl.disableVertexAttribArray(VERTEX_ARRAY);
	gl.disableVertexAttribArray(NORMAL_ARRAY);

    gl.bindBuffer(gl.ARRAY_BUFFER, null);
	gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);

	// Displays the demo name using the tools. For a detailed explanation, see the training course IntroducingPVRTools
	m_Print3D.displayDefaultTitle("", "", EPVRPrint3D.Logo.PowerVR);
	m_Print3D.flush(gl);

	// Swap the FBO that we want to render to
	m_i32CurrentFBO = 1 - m_i32CurrentFBO;
	//this.m_Scene.setCurrentFrame(m_i32Frame);
	++m_i32Frame;

	return true;
}

 WebGLFilmTV.prototype.drawPODScene= function(gl, mViewProjection, bDrawCamera){
//void WebGLFilmTV.prototype.DrawPODScene(PVRTMat4 &mViewProjection, bool bDrawCamera)

	// Clear the colour and depth buffer
	gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);

	// Get the position of the first light from the scene.
	let vLightPosition = this.m_Scene.getLightPosition(0);   //getLightPosition(0); //PVRTVec4

	for(let i = 0; i < this.m_Scene.data.numMeshNodes; ++i)
	{

	
		let Node = this.m_Scene.data.nodes[i];

		// Get the node model matrix
		let  mWorld = this.m_Scene.getWorldMatrix(Node.data.index);

		if(i === g_ui32CameraMesh)
		{
		
			if(!bDrawCamera) continue;

			// Rotate camera model
			mWorld = PVRMatrix4x4.matrixMultiply( PVRMatrix4x4.inverse( m_MiniCamView) , mWorld);
		}
		else if(i === g_ui32TvScreen) // If we're drawing the TV screen change to the black and white shader
		{
			
		     gl.useProgram(m_BWShaderProgram.uiId);
		}

		// Pass the model-view-projection matrix (MVP) to the shader to transform the vertices
		// mMVP;  //mModelView,
		let mMVP = PVRMatrix4x4.matrixMultiply(mViewProjection , mWorld);
		gl.uniformMatrix4fv(i === g_ui32TvScreen ? m_BWShaderProgram.uiMVPMatrixLoc :  m_ShaderProgram.uiMVPMatrixLoc,  gl.FALSE, mMVP.data);
//		gl.uniformMatrix4fv(  m_ShaderProgram.uiMVPMatrixLoc,  gl.FALSE, mMVP.data);

		// Pass the light position in model space to the shader
		//PVRTVec4 vLightPos;
		let value = PVRMatrix4x4.multiply( PVRMatrix4x4.inverse(  mWorld), vLightPosition);
        let vLightPos = new PVRVector3(value.data[0], value.data[1],value.data[2]) ;
		gl.uniform3fv(i === g_ui32TvScreen ? m_BWShaderProgram.uiLightPosLoc : m_ShaderProgram.uiLightPosLoc,  vLightPos.data);
		//gl.uniform3fv( m_ShaderProgram.uiLightPosLoc,  vLightPos.data);

		// Load the correct texture using our texture lookup table
		let uiTex = {};



		if(Node.data.materialIndex !== -1)
		{
             if(m_bFBOsCreated && Node.data.materialIndex === m_uiTVScreen && m_i32Frame != 0 ){
				 //console.log(1- m_i32CurrentFBO, m_uiTexture[1- m_i32CurrentFBO])
			 	uiTex = m_uiTexture[1- m_i32CurrentFBO];
			 }
			 else{
				uiTex = this.m_puiTextureIDs[Node.data.materialIndex];
			}
		}

	
		gl.bindTexture(gl.TEXTURE_2D, uiTex);

		/*
			Now that the model-view matrix is set and the materials ready,
			call another function to actually draw the mesh.
		*/
	
		this.drawMesh(gl, Node.data.index);

	    


		if(i === g_ui32TvScreen)
		{
			// Change back to the normal shader after drawing the g_ui32TvScreen
			gl.useProgram(m_ShaderProgram.uiId);
		}
	
	}
}

/*!****************************************************************************
 @Function		DrawMesh
 @Input			i32MeshIndex		Mesh index of the mesh to draw
 @Description	Draws a SPODMesh after the model view matrix has been set and
				the material prepared.
******************************************************************************/
//void WebGLFilmTV.prototype.DrawMesh(int i32MeshIndex)
 WebGLFilmTV.prototype.drawMesh= function(gl, i32MeshIndex)
{
	


  let Mesh = this.m_Scene.data.meshes[i32MeshIndex];	//SPODMesh&


	// bind the VBO for the mesh
	gl.bindBuffer(gl.ARRAY_BUFFER, m_puiVbo[i32MeshIndex]);

	// bind the index buffer, won't hurt if the handle is 0
	gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, m_puiIndexVbo[i32MeshIndex]);

	// Set the vertex attribute offsets
	//gl.vertexAttribPointer(VERTEX_ARRAY, 3, gl.FLOAT, gl.FALSE, Mesh.data.sVertex.nStride, Mesh.sVertex.pData);
	//gl.vertexAttribPointer(NORMAL_ARRAY, 3, gl.FLOAT, gl.FALSE, Mesh.data.sNormals.nStride, Mesh.sNormals.pData);

	let positions = Mesh.data.vertexElements["POSITION0"];
        let normals   = Mesh.data.vertexElements["NORMAL0"];
		let uvs       = Mesh.data.vertexElements["UV0"];


	gl.vertexAttribPointer(VERTEX_ARRAY, 3, gl.FLOAT, gl.FALSE, positions.stride, positions.offset);
	gl.vertexAttribPointer(NORMAL_ARRAY, 3, gl.FLOAT, gl.FALSE, normals.stride, normals.offset);


	 if(uvs) // Do we have texture co-ordinates?
	 {
	     gl.enableVertexAttribArray(TEXCOORD_ARRAY);
		// //gl.vertexAttribPointer(TEXCOORD_ARRAY, 2, gl.FLOAT, gl.FALSE, Mesh.psUVW[0].nStride, Mesh.psUVW[0].pData);
		gl.vertexAttribPointer(TEXCOORD_ARRAY, 2, gl.FLOAT, gl.FALSE, uvs.stride, uvs.offset);
		// Disable the uv attribute array
		gl.drawElements(gl.TRIANGLES, Mesh.data.faces.data.length, gl.UNSIGNED_SHORT, 0);
		gl.disableVertexAttribArray(TEXCOORD_ARRAY);
	}
else{


	// Draw the Indexed Triangle list
	gl.drawElements(gl.TRIANGLES, Mesh.data.faces.data.length, gl.UNSIGNED_SHORT, 0);
}



	 gl.bindBuffer(gl.ARRAY_BUFFER, null);
	 gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
}

}
/******************************************************************************
 End of file (OGLES2FilmTV.cpp)
******************************************************************************/
export default WebGLFilmTV;
